// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._zulp1b66{gap:var(--ds-space-050,4px)}._1e0c1txw{display:flex}\n._2lx21bp4{flex-direction:column}\n._k48p1wq8{font-weight:var(--ds-font-weight-medium,500)}\n._k48pmoej{font-weight:var(--ds-font-weight-bold,700)}\n._n3td1b66{padding-bottom:var(--ds-space-050,4px)}\n._syazi7uo{color:var(--ds-text,#292a2e)}", ""]);
// Exports
module.exports = exports;
